import { OperationType, Ticket } from "./Entity";

export class Futures extends Ticket {
  constructor() {
    super();
  }

  // Dados da operação
  id: number = null;
  operationDate: Date = null;
  settlementDate: Date = null;
  operationTypeId: OperationType = null;
  amount: number = null;
  tradingDate: Date = null;
  percentageDiscount: number = null;
  unitPrice: number = null;
  paperCode: string = null;
  paperSerie: string = null;
  annotations: string = null;

  // Dados da corretora
  broker: string = null;
  brokerCode: string = null;
  brokerAccount: string = null;
  brokerDocument: string = null;

  // Dados Carteira/Fundo
  portfolioName = "";
  portfolioCode = "";
  portfolioDocument = "";
  portfolioBank = null;
  portfolioBranch = null;
  portfolioAccount = "";
  portfolioB3Account = "";
  portfolioFundId: number = null;
  portfolioFundAccountId: number = null;
}
